module.exports = __webpack_public_path__ + "img/checkbox_image.27f023ef.png";